module.exports = __webpack_public_path__ + "static/media/app-argento-lab-768x591.96e67513.jpg";